import * as React from "react";
import BaseUI, { IBaseUI } from "src/engine/ui/BaseUI";
import PanelContext, { IPanelContext } from "src/engine/context/PanelContext";
import IUIItem from "src/engine/interface/IUIItem";
import UIManifest from "src/engine/ui/UIManifest";
import "./PCForm.scss";
import PropsUtils from "src/engineEditor/props/utils/PropsUtils";
import Utils from "src/lib/utils/Utils";
import Style from "src/lib/utils/Style";
import AutoContext from "src/engine/decorator/AutoContext";
import FormItem from "./FormItem";
import FormRule from "./FormRule";
import EditConfig from "src/engineEditor/config/EditConfig";

const { createForm } = require("rc-form");

export interface IPCForm extends IBaseUI {
    children: IUIItem[];
    label?: boolean;
    layout?: "vertical" | "inline" | "horizontal";
    labelLayout?: "vertical" | "horizontal";
    labelAlign?: "left" | "right";
    labelStyle?: any;
    itemStyle?: any;
    labelCol?: number;
    onChange?: any;
    wrapperCol?: number;
    buttons?: IUIItem[];
    buttonsOut?: boolean;
    required?: { [key: string]: boolean };
    //传递处理方法
    handleRet?: any;
    specialScript?: string;
    specialItem?: string;
    disabledChild?: string[];
    initValues?: any;
    isLastDelete?: boolean;
    noMerge?: boolean;
    errorStyle?: any;
    hiddenRequireLabelFlag?: any;
    noPanelForm?: boolean;
    //额外执行校验数据
    checkData?: { [key: string]: any };
    rankLabel?: boolean;
    autoParse?: boolean;
    // 提交时是否获取错误信息
    submitOnParse?: boolean;
}

interface IState {
    flag?: boolean;
    data?: any;
}

@UIManifest.declareGG(["ggValue", "dataValue"], "PCForm", "Form表单", UIManifest.Type.Mobile)
class PCForm extends BaseUI<IPCForm, IState> {
    FormIn: any;

    form: any;

    ISMAN?: boolean;

    constructor(props: IPCForm) {
        super(props);
        this.state = { flag: false };
        this.FormIn = createForm()((item: any) => {
            return item.renderForm(item.form);
        });

        this.ISMAN = EditConfig.EDITOR_TEMPLATE_SERVER === "man";
    }

    onSubmit = (callback: any) => {
        const { submitOnParse = false } = this.props;
        //判断是否需要检测
        this.form.validateFields((err: any, values: any) => {
            //判断错才执行下一步
            if (!err) {
                const { handleRet, noPanelForm } = this.props;
                // 属性 noPanelForm 是为了兼容在 PCModal 中也传 handleRet 方法，导致后续逻辑失效的问题。
                if (handleRet && !noPanelForm) {
                    // 处理编辑文章的时候 先 create/update, 再 batchSave 的逻辑
                    this.handleRetMiddle();
                } else if (callback) {
                    if (submitOnParse) {
                        callback({ REV: true, DATA: this.onSave() });
                    } else {
                        callback(this.onSave());
                    }
                }
            } else {
                if (submitOnParse) {
                    callback({ REV: false, DATA: err });
                }
            }
        });
    };

    /**
     * 校验某个表单项
     * @param callback
     */
    validateItems = (callback: any, oldValue?: any) => {
        const validateArray = oldValue.split(",");
        this.form.validateFields(validateArray, (error: any, value: any) => {
            if (error) return;
            // console.log(value);
            callback(value);
        });
    };

    setValueGroupCache: string[] = [];
    setValueMapCache: string[] = [];
    setFieldsValue = (callback: any, oldValue: { [key: string]: any } = {}) => {
        if (typeof oldValue !== "object") {
            console.warn("传入数据错误");
            return;
        }
        const defaultDict: any = {},
            mapDict: any = {},
            groupDict: any = {};
        Object.keys(oldValue).map((key: string) => {
            if (this.setValueGroupCache.indexOf(key) >= 0) {
                groupDict[key] = oldValue[key];
            } else if (this.setValueMapCache.indexOf(key) >= 0) {
                mapDict[key] = oldValue[key];
            } else {
                defaultDict[key] = oldValue[key];
            }
        });
        this.form.setFieldsValue(defaultDict);
        this.setFieldsGroupValue(callback, groupDict);
    };

    // 设置PCFormGroup类型的数据
    setFieldsGroupValue = (callback: any, oldValue: { [key: string]: any[] } = {}) => {
        const keyArray = Object.keys(oldValue);
        if (keyArray.length === 0) return;
        const cache = {};
        for (const key of keyArray) {
            // const group:any[] = ;
            oldValue[key].map((item: any, index: number) => {
                const numberKey = `${key}.${index}`;
                Object.keys(item).map((k: string) => {
                    cache[`${numberKey}.${k}`] = item[k];
                });
            });
        }
        this.setFieldsValue(callback, cache);
    };

    resetFields = (callback: any, oldValue: any) => {
        this.form.resetFields();
        if (callback) {
            callback(oldValue);
        }
    };

    // // 编辑文章时传给button的click回调逻辑
    handleRetMiddle = () => {
        const { handleRet, source, data } = this.props;
        if (!source) {
            handleRet(this.onSave());
        } else {
            let params = {};
            if (Array.isArray(data)) params = this.onSave();
            else params = { ...data, ...this.onSave() };
            this.sourceContext.execSource(source, params, (ret: any) => {
                if (ret === false || ret.error === true) {
                    // window.alert(`网络出错，请重试！`);
                } else {
                    handleRet(ret);
                }
            });
        }
    };

    onSave = (getData?: boolean) => {
        const { data, noMerge, dataSource = {} } = this.props;
        let formData = this.form.getFieldsValue();
        if (!noMerge) {
            formData = { ...dataSource, ...data, ...formData };
        } else {
            formData = Utils.deepClone(formData);
        }
        console.log("[PCForm]:formData", noMerge, formData, "-data-", data);
        if (getData === true) this.setState({ data: formData });
        return formData;
    };

    getData = () => {
        this.onSave(true);
    };

    onClear = () => {
        this.form.resetFields();
    };

    renderButtons(uiItem: IUIItem[] = [], context: IPanelContext) {
        const { onClear, onSubmit, onSave, validateItems, setFieldsValue, resetFields } = this;
        const props: any = { onClear, onSubmit, onSave, validateItems, setFieldsValue, resetFields, formProps: this.props, stateData: this.state.data };
        const { getFieldsValue } = this.form;
        props.getData = this.getData;
        const pProps = this.props as any;
        if (pProps.onClose) props.onClose = pProps.onClose;
        if (pProps.handleRet) props.onClick = onSubmit;
        const { btnWrapStyle } = Style.getMainStyle("PCForm", this.props);
        const getFieldValue = getFieldsValue();
        // Form 表单中 Button 的显示规则
        const uiItemList = uiItem.filter((item) => {
            const ioption: any = this.formRule.getItemRule(item, getFieldValue);
            return ioption.show !== false;
        });
        return <div style={btnWrapStyle}>{this.renderUIItems(uiItemList, context, props)}</div>;
    }

    handleRetClick = () => {
        const { source } = this.props;
        console.log(source);
    };

    getInitValue(name: string) {
        const { data, uiItem, dataSource } = this.props;
        const nD = { ...dataSource, ...data };
        // console.log('[PCForm]:getInitValue', data, name, PropsUtils.getValue(data, name));
        const ret = PropsUtils.getValue(nD, name);
        if (ret === undefined) {
            const { data: uData } = uiItem.props;
            //优先检查自定义数据
            if (uData && uData[name]) {
                return uData[name];
            }
        }
        return ret;
    }

    formRule = new FormRule(this.props.uiItem);

    specialRender = (uiItem: IUIItem, context: IPanelContext): any => {
        return null;
    };

    createName(child: IUIItem) {
        const { ename, cname } = child.info;
        if (!this.ISMAN) {
            return { ename, cname };
        }
        const m_ename = child.props._ename || ename;
        const m_cname = child.props._cname || cname;
        return { ename: m_ename, cname: m_cname };
    }

    renderItem = (child: IUIItem, namePrex: string = "", childProps: any = {}, props: any = {}, noName: boolean = false, rank?: number) => {
        const component = this.specialRender(child, this.mPanelContext);
        if (component !== null) return component;
        const { disabledChild = [], checkData = {}, disabledForm, rankLabel } = this.props as any;
        const { getFieldError, getFieldDecorator, getFieldsValue } = this.form;
        const { ename, cname } = this.createName(child);
        const name = namePrex + (noName === true ? "" : ename);

        const formData = getFieldsValue();
        //获取规则
        const ioption: any = this.formRule.getItemRule(child, formData, checkData);
        if (ioption.show === false) return null;
        //如果不满足显示条件
        ioption.initialValue = this.getInitValue(name);
        // if (ioption.initialValue === undefined) delete ioption.initialValue;
        //formItem属性
        props = {
            required: ioption.required,
            showCname: child.props.showCname,
            error: getFieldError(name),
            ...props,
            label: rankLabel ? `${rank ? rank + "." : ""}${cname}` : cname,
        };
        // 挪到下边单独处理，否则会对 PCForm 上的属性造成影响
        // 子组件上加 childItemStyle 改变 form 统一分配的item样式；
        if (child.props.childItemStyle) props.itemStyle = child.props.childItemStyle;
        if (child.props.childLabelStyle) props.labelStyle = child.props.childLabelStyle;
        //子组件属性
        childProps = {
            ...ioption.props,
            ...childProps,
            formData,
            setFieldsValue: this.setFieldsValue,
            resetFields: this.resetFields,
            validateItems: this.validateItems,
        };
        if (disabledChild.indexOf(ename) >= 0 || disabledForm) childProps.disabled = true;
        delete ioption.props;
        // childProps.formData = formData;
        // childProps.disabled = disabledChild.indexOf(ename) >= 0;
        // const childProps: any = { formData };

        let decorator;
        if (child.ui === "PCFormGroup" || child.ui === "PCFormMap") {
            console.log(`[name]`, name, ename);
            if (child.ui === "PCFormGroup") this.setValueGroupCache.push(name);
            else this.setValueMapCache.push(name);
            childProps.renderItem = this.renderItem;
            childProps.renderFormItem = this.renderFormItem;
            childProps.form = this.form;
            childProps.namePrex = namePrex;
            childProps.initialValue = ioption.initialValue;

            if (typeof childProps.initialValue === "string") {
                try {
                    const { autoParse } = this.props;

                    if (autoParse !== false) childProps.initialValue = JSON.parse(childProps.initialValue);
                } catch (err) {
                    if (child.ui === "PCFormGroup") {
                        childProps.initialValue = [];
                    } else {
                        childProps.initialValue = {};
                    }
                }
            }
            decorator = (ui: any) => ui;
        } else {
            decorator = getFieldDecorator(name, ioption);
        }

        // console.log('[PCForm]:', name, childProps);
        // return <FormItem  {...props} error={getFieldError(name)} hideRequiredMark={hiddenRequireLabelFlag}>
        //     {decorator(this.renderUIItem(child, this.mPanelContext, childProps))}
        // </FormItem>
        return this.renderFormItem(props, decorator(this.renderUIItem(child, this.mPanelContext, childProps)));
    };

    renderFormItem = (props: any, children: any) => {
        const { hiddenRequireLabelFlag = false, label, layout = "vertical" } = this.props;

        return (
            <FormItem showLabel={label} {...this.formItemStyle} layout={layout} {...props} hideRequiredMark={hiddenRequireLabelFlag}>
                {children}
            </FormItem>
        );
    };

    renderFormItems(chidlren: IUIItem[]) {
        return chidlren.map((child: IUIItem, index: number) => {
            return this.renderItem(child, "", {}, {}, false, index + 1);
        });
    }

    mPanelContext: IPanelContext;

    formItemStyle: any;

    initStyle() {
        const styles = Style.getMainStyle(["labelStyle", "wrapperStyle", "itemStyle", "errorStyle"], this.props);
        const { labelAlign = "left", labelCol, wrapperCol } = this.props;
        if (labelCol && wrapperCol) {
            const labelWidth = Math.round((labelCol / (labelCol + wrapperCol)) * 100);
            styles.labelStyle = { ...styles.labelStyle, width: `${labelWidth}%`, textAlign: labelAlign };
            styles.wrapperStyle = { ...styles.wrapperStyle, width: `${100 - labelWidth}%` };
        }
        this.formItemStyle = styles;
        // console.log('[PCFormItem]:222', styles, this.formItemStyle);
    }

    /**
     * form区域的生成
     */
    @AutoContext(PanelContext, "mPanelContext")
    renderForm() {
        const { children = [], buttons, buttonsOut = false } = this.props;
        this.initStyle();
        return [
            <div key={0} className={"react-form"} style={this.getStyle()}>
                {this.renderFormItems(children)}
                {!buttonsOut ? this.renderButtons(buttons, this.mPanelContext) : null}
            </div>,
            buttonsOut ? this.renderButtons(buttons, this.mPanelContext) : null,
        ];
    }

    renderAct() {
        //绑定FormUI生成
        const FormIn = this.FormIn;
        return (
            <FormIn
                renderForm={(form: any) => {
                    this.form = form;
                    return this.renderForm();
                }}
            />
        );
    }
}

export default PCForm;
